__turbopack_context__.v({
  "wrapper": "_2UJN0G_wrapper",
});
